<template>
  <div class="dj-reset">
    <div class="dj-reset__card">
      <router-link to="/" class="dj-reset__logo-link">
        <v-img
          class="mx-auto"
          :src="require('../../assets/logo.png')"
          max-width="56"
          contain
        ></v-img>
      </router-link>

      <p class="dj-reset__eyebrow">Account security</p>
      <h2 class="dj-reset__title">Reset password</h2>
      <p class="dj-reset__subtitle">
        Choose a new password for your account.
      </p>

      <div class="dj-reset__info">
        <div class="dj-reset__info-row">
          <span class="dj-reset__info-label">Email</span>
          <span class="dj-reset__info-value">{{ user.email }}</span>
        </div>
        <div class="dj-reset__info-row">
          <span class="dj-reset__info-label">Role</span>
          <span class="dj-reset__info-value">{{ roleName }}</span>
        </div>
      </div>

      <v-text-field
        v-model="form.password"
        type="password"
        outlined
        label="New Password"
        prepend-inner-icon="mdi-lock-outline"
        :error-messages="errors.password"
        hide-details="auto"
        class="dj-reset__field"
      ></v-text-field>
      <v-text-field
        v-model="form.password_confirmation"
        type="password"
        outlined
        label="Confirm Password"
        prepend-inner-icon="mdi-lock-check-outline"
        hide-details="auto"
        class="dj-reset__field"
      ></v-text-field>

      <v-btn
        block
        large
        color="primary"
        class="dj-reset__submit"
        :loading="isLoading"
        @click="resetPassword"
      >
        Reset Password
      </v-btn>

      <!-- Password Reset Success Message -->
      <v-dialog v-model="isPasswordReseted" max-width="440" persistent>
        <v-card class="dj-reset__dialog">
          <div class="dj-reset__dialog-icon">
            <v-icon size="40" color="success">mdi-check-circle-outline</v-icon>
          </div>
          <h3 class="dj-reset__dialog-title">Password reset successfully</h3>
          <p class="dj-reset__dialog-text">
            Your password has been updated. Please sign in again to continue.
          </p>
          <v-btn block large color="primary" @click.stop="closeDialog"
            >Continue to sign in</v-btn
          >
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ResetPasswordPage",
  data() {
    return {
      isPasswordReseted: false,
      form: {
        email: "",
        password: "",
        password_confirmation: "",
      },
      isLoading: false,
    };
  },
  mounted() {
    this.form.email = this.user.email;
  },
  methods: {
    async resetPassword() {
      try {
        this.isLoading = true;
        await axios.post("/reset_password", this.form);
        let user = this.user;
        user.is_password_reseted = 1;
        await axios.patch(`/users/${user.id}`, user);
        this.isLoading = false;
        this.isPasswordReseted = true;
      } catch {
        this.isLoading = false;
      }
    },
    closeDialog() {
      this.isPasswordReseted = false;
      this.$router.push("/auth/login");
    },
  },
};
</script>

<style scoped>
.dj-reset {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: radial-gradient(
      120% 80% at 50% -10%,
      var(--dj-accent-soft) 0%,
      transparent 55%
    ),
    var(--dj-bg);
}
.dj-reset__card {
  width: 100%;
  max-width: 440px;
  background: var(--dj-surface);
  border: 1px solid var(--dj-border);
  border-radius: 20px;
  box-shadow: var(--dj-shadow-lg);
  padding: 40px 40px 36px;
}
.dj-reset__logo-link {
  display: block;
  margin-bottom: 20px;
}
.dj-reset__eyebrow {
  text-align: center;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--dj-accent);
  margin: 0 0 6px;
}
.dj-reset__title {
  text-align: center;
  font-size: 1.7rem;
  font-weight: 800;
  letter-spacing: -0.025em;
  color: var(--dj-text);
  margin: 0 0 6px;
}
.dj-reset__subtitle {
  text-align: center;
  font-size: 0.92rem;
  color: var(--dj-text-soft);
  margin: 0 0 24px;
}
.dj-reset__info {
  background: var(--dj-panel);
  border: 1px solid var(--dj-border);
  border-radius: var(--dj-radius);
  padding: 6px 16px;
  margin-bottom: 22px;
}
.dj-reset__info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}
.dj-reset__info-row + .dj-reset__info-row {
  border-top: 1px solid var(--dj-border);
}
.dj-reset__info-label {
  font-size: 0.8rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--dj-text-faint);
  font-weight: 600;
}
.dj-reset__info-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--dj-text);
}
.dj-reset__field {
  margin-bottom: 16px;
}
.dj-reset__submit {
  margin-top: 6px;
  height: 48px !important;
  border-radius: var(--dj-radius-sm) !important;
}
.dj-reset__dialog {
  text-align: center;
  padding: 34px 30px 30px;
  border-radius: 20px !important;
}
.dj-reset__dialog-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: oklch(0.66 0.15 155 / 0.12);
}
.dj-reset__dialog-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--dj-text);
  margin-bottom: 8px;
}
.dj-reset__dialog-text {
  font-size: 0.9rem;
  color: var(--dj-text-soft);
  margin-bottom: 22px;
}
</style>
